import { useCallback, useEffect, useState } from "react";
import { IEsteira } from "../../interfaces/IEsteira";
import { IRelatorio } from "../../interfaces/IRelatorio";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDrop } from "react-dnd";
import Cartao from "./cartao";
import RelatoriosService from "../../services/RelatoriosService";
import moment from "moment";
import ModalCardImport from "./modal-card-import";
import cartaoNovaService from "../../services/cartaoNovaService";
import extratoNovaService from "../../services/extratoNovaService";
import Swal from "sweetalert2";
import ModalCard from "./modal-card";
import { uniqueId } from "lodash";

/*Tradução */
import './../../../i18n/config';
import { useTranslation } from 'react-i18next';
import { formatDefault } from "../../utils/DateUtil";
const Coluna = ({ title, value, data, esteira, onUpdateCard }: { title: string, value: string, data: IRelatorio[], esteira: IEsteira | undefined, onUpdateCard: Function }) => {

    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(false);
    const { t } = useTranslation();
    const [modal, setModal] = useState<any>({
        show: false,
        acc: null
    });

    const [, drop] = useDrop(() => ({
        accept: 'CARD',
        drop: async (item: any) => {
            if (value == "Em processamento") {
                setShowModal(item.codigo, item.id)
            }

            if (item.status === "Em processamento") {
                Swal.fire({
                    text: 'Não é possível alterar cartões que estão em processamento.',
                    timer: 5000,
                    icon: 'error',
                    showConfirmButton: false
                });
                return;
            }

            if (item.status === "Pendentes" && value !== "Em processamento") {
                Swal.fire({
                    text: 'Cartões pendentes podem apenas ir para processamento.',
                    timer: 5000,
                    icon: 'error',
                    showConfirmButton: false
                });
                return;
            }

            if (item.status != "Em processamento" && item.status !== "Pendentes" && (value === "Em processamento" || value === "Pendentes")) {
                Swal.fire({
                    text: 'Não foi possível retornar o cartão.',
                    timer: 5000,
                    icon: 'error',
                    showConfirmButton: false
                });
                return;
            }

            onUpdateCard(item.codigo, value);
            cartaoNovaService.atualizarStatus(item.id, value).catch(() => onUpdateCard(item.codigo, item.status));
        }
    }));

    const setShowModal = useCallback((acc: String, id: number) => {
        setModal((old: any) => {
            return {
                show: !old.show,
                acc,
                id
            }
        });
    }, []);

    const reprocess = useCallback((acc: String) => {
        const value = "Em processamento";
        const itemF = data.find(f => f.contaEmpresa === acc);
        onUpdateCard(acc, value);
        cartaoNovaService.atualizarStatus(itemF?.id || 0, value).catch(() => onUpdateCard(acc, value));
        setShowModal('', 0);
    }, []);

    return (
        <div ref={drop} style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ width: '272px', marginRight: '15px', maxHeight: '350px' }}>
                <div style={{ width: '100%', padding: '15px 10px', display: 'flex', alignItems: 'center', justifyContent: 'start', backgroundColor: '#EBECF0', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}>
                    <p style={{ wordBreak: 'break-word', fontSize: '16px', fontWeight: 'bold', margin: '0', marginRight: '5px', textAlign: 'justify' }}>{title}</p>
                </div>
                {
                    !loading ? (
                        <div id={`scrollableDiv-${value}`} style={{ width: '100%', maxHeight: '216px', overflow: 'auto' }}>
                            <InfiniteScroll
                                style={{ overflow: 'hidden' }}
                                dataLength={data.length}
                                next={() => { }}
                                hasMore={hasMore}
                                scrollableTarget={`scrollableDiv-${value}`}
                                loader={
                                    <div className='col-md-12 mt-2'>
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            {t("Aguarde...")}
                                        </span>
                                    </div>
                                }
                                endMessage={
                                    <p style={{ textAlign: 'center' }}>
                                        <b>{t("Todos os cards foram carregados")}</b>
                                    </p>
                                }
                                refreshFunction={() => { }}
                                pullDownToRefresh
                                pullDownToRefreshThreshold={50}
                            >
                                {data.map((item) => (
                                    <Cartao key={uniqueId()} updateCard={onUpdateCard} data={item} showModal={setShowModal} onShowPreview={(afterLoading: any) => {
                                        RelatoriosService.pegarUrlImpressaoNovo(esteira?.empresaID || 0, [{
                                            conta: item?.contaEmpresa || '',
                                            id: item?.id || 0
                                        }], true, formatDefault(esteira?.periodoInicioString), formatDefault(esteira?.periodoFimString), (x) => {
                                            afterLoading();
                                            window.open(URL.createObjectURL(x), '_blank');
                                        });
                                    }} />
                                ))}
                            </InfiniteScroll>
                        </div>
                    ) : (
                        <div className='col-md-12 mt-2'>
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                Aguarde...
                            </span>
                        </div>
                    )
                }
            </div>
            <div style={{ width: '272px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'start', backgroundColor: '#EBECF0', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}>
                <p style={{ fontSize: '14px', margin: '0', paddingLeft: '15px', textAlign: 'justify' }}>{t("Total de Contas")}: {data?.length || 0}</p>
            </div>
            {value == "Em processamento" ? <ModalCardImport esteiraID={esteira?.id || 0} acc={modal.acc} show={modal.show} toggleModal={(force: boolean) => {
                setShowModal('', 0);

                if (force) {
                    cartaoNovaService.atualizarStatus(modal.id, "Pendentes");
                }

            }} /> : <ModalCard esteiraID={esteira?.id || 0} acc={modal.acc} show={modal.show} toggleModal={() => setShowModal('', 0)} reprocess={reprocess} />}
        </div>
    );
}

export default Coluna;